import { useTranslation } from 'react-i18next';

/**
 * The two column headings of a visibility grid — who decides, and where it
 * starts — shown ONCE above the rows rather than repeated inside each.
 *
 * `aria-hidden`: every row is already fully self-describing (a fieldset naming
 * the context, a group of its own and a labelled control), so this is a scan aid
 * for sighted operators, not a second accessible name.
 *
 * Shared by the per-question matrix and the section-wide defaults dialog so the
 * two read as one surface — the reason P10.6e1 was built before P10.6e2.
 */
export function VisibilityColumnCaptions() {
  const { t } = useTranslation('questions');

  return (
    <div aria-hidden="true" className="hidden gap-md px-sm md:grid md:grid-cols-2 md:items-end">
      <span className="text-caption font-medium text-muted-foreground">
        {t('visibility.columns.decision')}
      </span>
      <span className="text-caption font-medium text-muted-foreground">
        {t('visibility.columns.default')}
      </span>
    </div>
  );
}
